import { render, staticRenderFns } from "./PointsRule.vue?vue&type=template&id=afd21860&scoped=true"
import script from "./PointsRule.vue?vue&type=script&lang=js"
export * from "./PointsRule.vue?vue&type=script&lang=js"
import style0 from "./PointsRule.vue?vue&type=style&index=0&id=afd21860&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd21860",
  null
  
)

export default component.exports